export const QueryParams = {
  ITEM: 'item',
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
  SENDER_TYPE: 'senderType',
}
